import React from "react";
import classNames from "classnames";
import Carousel from "./Carousel";
import "./ImageCarousel.scss";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Thumbnail, ThumbnailSize } from "./Thumbnail";

export { ThumbnailSize as ImageCarouselSize };
export type CarouselImage = {
  fileId: string;
  url: string | null;
  fileType: string;
  thumbnails?: {
    [K in ThumbnailSize]: string | null;
  };
};

export const ImageCarousel = ({
  images,
  size,
  editing,
  onDelete,
  onClick,
  isSmallScreen,
}: {
  images: CarouselImage[];
  size: ThumbnailSize;
  editing?: boolean;
  onDelete?: (index: number) => void;
  onClick?: (index: number) => void;
  isSmallScreen?: boolean;
}) => {
  return (
    <Carousel options={{ align: "start", dragFree: true }}>
      {images.map((image, index) => (
        <div key={index} className='carousel-image tw-relative tw-m-2 tw-inline-block'>
          <Thumbnail image={image} size={size} onClick={() => onClick?.(index)} />
          {editing && (
            <button
              className={classNames({ "image-delete-button": true, "tw-opacity-100": isSmallScreen })}
              onClick={() => onDelete?.(index)}
            >
              <FontAwesomeIcon icon={faXmark} className='tw-h-4 tw-w-4' />
            </button>
          )}
        </div>
      ))}
    </Carousel>
  );
};
